import jQuery from 'jquery';
import {Component} from 'react';
import {connect} from 'react-redux';

const Properties = [
    'showFavouritesOnly',
    'showProductLegend',
    'animationSpeed',
    'animationStart',
    'animationStop',
    'locationID',
    'resolution',
    'showMatrix',
    'startHour',
    'panelOpen',
    'productID',
    'offset',

    /* OSM settings */
    'OSMLayer',
    'OSMColored',
    'OSMOpacity',
    'FAIEnabled',

    /* Route settings */
    'startHour',
    'startMinute',
    'plane',
    'climbRate',
    'descentRate',
    'cruisingSpeed',
    'cruisingAltitude',
    'skillLevel',
    'hourlyAverage',

    /* index has to be last to be excluded
       from diff when animating */
    'index',
];

const getDiff = (previous, current) => {
    const {isAnimating} = current;
    const end = Properties.length - Number(isAnimating);
    const properties = Properties.slice(0, end);

    return properties.filter(key => key in previous && previous[key] === current[key] ? false : key);
};

class UserDefaults extends Component {

    constructor(props) {
        super(props);

        this.sync = this.sync.bind(this);

        this.timer = 0;
        this.last = props;
    }

    render() {
        return this.props.children;
    }

    componentDidUpdate(prevProps) {
        const {isDragging, isAnimating} = this.props;

        if (isDragging) return;

        if (isAnimating) {
            const diff = getDiff(prevProps, this.props);

            /* nothing except index or is animating has changed, ignore */
            if (diff.length === 0) return;
        }

        if (this.timer) clearTimeout(this.timer);

        this.timer = setTimeout(this.sync, 500);
    }

    componentWillUnmount() {
        if (this.timer) clearTimeout(this.timer);
    }

    sync() {
        this.timer = 0;

        const {props, last} = this;
        const diff = getDiff(last, props);

        if (diff.length === 0) return null;

        const data = {};

        diff.forEach(key => {
            data[key] = props[key];
        });

        const {CSRFMiddlewareToken, url} = props;

        return jQuery.ajax(url, {
            type: 'POST',
            dataType: 'json',
            data: JSON.stringify(data),
            contentType: 'application/json',
            headers: {
                'X-CSRFToken': CSRFMiddlewareToken,
            },
            success: ({success}) => {
                if (success) this.last = props;
            },
        });
    }

}

const mapStateToProps = state => {
    const {isAnimating, isDragging, userDefaultsURL, CSRFMiddlewareToken} = state;
    const props = {url: userDefaultsURL, isAnimating, isDragging, CSRFMiddlewareToken};

    Properties.forEach(prop => {
        props[prop] = state[prop];
    });

    return props;
};

export default connect(mapStateToProps)(UserDefaults);
